{
  "version": 1,
  "asset_id": "77df8672-3d1a-44a1-96ec-2c7e84686595",
  "project_id": "449b2c5b-fdd9-48b8-8f0a-7dd2027bc221",
  "url": "/__l5e/assets-v1/77df8672-3d1a-44a1-96ec-2c7e84686595/blackfamilyweekend.webp",
  "r2_key": "a/v1/449b2c5b-fdd9-48b8-8f0a-7dd2027bc221/77df8672-3d1a-44a1-96ec-2c7e84686595/blackfamilyweekend.webp",
  "original_filename": "blackfamilyweekend.webp",
  "size": 2148856,
  "content_type": "image/png",
  "created_at": "2026-06-12T03:02:28Z"
}
